import { setPreference } from '@fs/zion-preferences'
import { useStatusOverlay } from '@fs/zion-ui'
import { useEffect, useRef } from 'react'

export default function OptOutV2(): null {
  const showStatusOverlay = useStatusOverlay()
  const hasOptedOut = useRef(false)

  useEffect(() => {
    if (hasOptedOut.current) return

    hasOptedOut.current = true
    setPreference('tree.newMerge2', false)
      .then(() => {
        // TODO translations
        showStatusOverlay({ message: 'You have opted out of the new merge experience.' })
        return undefined
      })
      .catch(() => {
        showStatusOverlay({
          message: 'There was an error opting out of the new merge experience. Please try again later.',
        })
      })
  }, [showStatusOverlay])

  return null
}
